/**
 * Isolated preview for the LineupsPitch component with mocked lineups.
 * Renders two variants side by side (small screens: stacked):
 *   1. Current — badge (circle + gradient) + name pill
 *   2. Number-only — no badge circle, just big colored number + name pill
 *
 * Route: `/pitch-preview` (public, no auth). Meant as a design sandbox.
 * Safe to remove once the pitch UI is finalised.
 */
import React, { useState } from 'react';
import LineupsPitch from '../components/LineupsPitch';

const MOCK_LINEUPS = [
  {
    team_id: 497,
    team_name: 'AS Roma',
    formation: '3-4-2-1',
    starting_xi: [
      { name: 'Svilar', number: 99, position: 'P' },
      { name: 'Mancini', number: 23, position: 'D' },
      { name: 'Ndicka', number: 5, position: 'D' },
      { name: 'Hermoso', number: 22, position: 'D' },
      { name: 'Wesley', number: 43, position: 'C' },
      { name: 'Cristante', number: 4, position: 'C' },
      { name: 'Kone', number: 17, position: 'C' },
      { name: 'Angelino', number: 3, position: 'C' },
      { name: 'Soule', number: 18, position: 'C' },
      { name: 'Dybala', number: 21, position: 'C' },
      { name: 'Ferguson', number: 11, position: 'A' },
    ],
    substitutes: [],
    predicted: true,
  },
  {
    team_id: 505,
    team_name: 'Inter',
    formation: '3-5-2',
    starting_xi: [
      { name: 'Martinez J.', number: 1, position: 'P' },
      { name: 'Akanji', number: 25, position: 'D' },
      { name: 'Bisseck', number: 31, position: 'D' },
      { name: 'Bastoni', number: 95, position: 'D' },
      { name: 'Dumfries', number: 2, position: 'C' },
      { name: 'Barella', number: 23, position: 'C' },
      { name: 'Zielinski', number: 7, position: 'C' },
      { name: 'Diouf', number: 17, position: 'C' },
      { name: 'Dimarco', number: 32, position: 'C' },
      { name: 'Martinez L.', number: 10, position: 'A' },
      { name: 'Thuram', number: 9, position: 'A' },
    ],
    substitutes: [],
    predicted: true,
  },
];

const MOCK_CARD_PRED = {
  home: {
    card: { player: 'Cristante', probability: 0.42, reason: 'Duello centrale' },
    scorer: { player: 'Dybala', probability: 0.38, reason: 'Rigorista designato' },
  },
  away: {
    card: { player: 'Barella', probability: 0.45, reason: 'Ammonito 3/5 partite' },
    scorer: { player: 'Thuram', probability: 0.4, reason: 'Bomber di squadra' },
  },
};

export default function PitchPreviewPage() {
  const [variant, setVariant] = useState('current');

  React.useEffect(() => {
    // Toggle body class so the LineupsPitch can switch style. We pass
    // the variant through a data attribute picked up by CSS variables
    // — the component itself reads no props for this preview.
    document.body.dataset.pitchVariant = variant;
    return () => { delete document.body.dataset.pitchVariant; };
  }, [variant]);

  return (
    <div style={{ minHeight: '100vh', background: '#0b0b0b', padding: 16, color: '#fff', fontFamily: 'system-ui, sans-serif' }}>
      <h1 style={{ fontSize: 18, marginBottom: 12 }}>Pitch preview · variante <b>{variant}</b></h1>
      <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
        <button
          onClick={() => setVariant('current')}
          style={{ padding: '6px 12px', borderRadius: 8, background: variant === 'current' ? '#f59e0b' : '#333', color: '#fff', border: 0, fontWeight: 700 }}
        >
          Con pallini
        </button>
        <button
          onClick={() => setVariant('number-only')}
          style={{ padding: '6px 12px', borderRadius: 8, background: variant === 'number-only' ? '#f59e0b' : '#333', color: '#fff', border: 0, fontWeight: 700 }}
        >
          Solo numero
        </button>
      </div>
      <LineupsPitch
        lineups={MOCK_LINEUPS}
        cardPrediction={MOCK_CARD_PRED}
        isPredicted
      />
    </div>
  );
}
